import { render, staticRenderFns } from "./popup-generate-self-process.vue?vue&type=template&id=0a9e0102&scoped=true"
import script from "./popup-generate-self-process.vue?vue&type=script&lang=js"
export * from "./popup-generate-self-process.vue?vue&type=script&lang=js"
import style0 from "./popup-generate-self-process.vue?vue&type=style&index=0&id=0a9e0102&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e0102",
  null
  
)

export default component.exports